import api from "./api";
import ApiResponse from "src/interfaces/ApiResponse";

export function RelatorioFiltrar(input: any) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_RELATORIO + "/relatorio/filtrar",
    {
      params: input,
    }
  );
}

export function RelatorioIncluir(input: any) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_RELATORIO + "/relatorio/incluir",
    input
  );
}

export function RelatorioAtualizar(input: any) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_RELATORIO + "/relatorio/atualizar",
    input
  );
}

export function RelatorioExcluir(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_RELATORIO + "/relatorio/excluir?id=" + id
  );
}

export function RelatorioBaixar(id: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_RELATORIO + "/relatorio/baixar?id=" + id,
    {
      responseType: "blob",
    }
  );
}

export function RelatorioImprimir(input: any) {
  return api.post(
    process.env.REACT_APP_API_BASE_URL_RELATORIO + "/relatorio/imprimir",
    input,
    {
      responseType: "blob",
    }
  );
}
